module.exports = __webpack_public_path__ + "static/sample-pack-6686b7a04624620cfd6956e7adde4980.jpg";